export default "__VITE_ASSET__Dh0BleGC__"